import React from 'react';
import { Link } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  Typography,
  Avatar,
  Tooltip,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MenuHamburguerArrow from '../../components/MenuHamburgerArrow';
import { PROFILE } from '../../routes/index';

const logo = '/img/logo/logo-contacta-abogado.svg';
const maleAvatar = '/img/avatars/avatares-cuadro-h.svg';
const femaleAvatar = '/img/avatars/avatares-cuadro-m.svg';
const lawFirmAvatar = '/img/avatars/avatares-cuadro-logo.svg';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  marginRight: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  avatar: {
    cursor: 'pointer',
  },
}));

export default ({
  avatar,
  profile,
  notifications,
  isExpandedSideMenu,
  handleOpenSideMenu,
  handleOpenMenu,
}) => {
  const classes = useStyles();
  const isTablet = useMediaQuery('(max-width:768px)');
  const defaultAvatar =
    profile && profile.role === 'lawyer'
      ? profile.genero === 'male'
        ? maleAvatar
        : femaleAvatar
      : lawFirmAvatar;

  return (
    <div className={classes.root}>
      <AppBar position="fixed">
        <Toolbar>
          <div
            style={{
              maxWidth: 1360,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              margin: '0 auto',
              padding: 0,
            }}
          >
            {!isTablet && (
              <Link to='/'>
                <img src={logo} alt="logo" className={classes.marginRight} />
              </Link>
            )}

            <div className={classes.title}>
              <MenuHamburguerArrow
                handleClick={handleOpenSideMenu}
                isChecked={!isExpandedSideMenu}
              />
            </div>

            {isTablet && 
              <Link to='/'>
                <img src={logo} alt="logo" />
              </Link>
            }

            {!isTablet && (
              <>
                <IconButton
                  color="inherit"
                  aria-label="notifications"
                  className={classes.marginRight}
                  onClick={handleOpenMenu}
                >
                  <Badge
                    badgeContent={notifications && notifications.length}
                    max={99}
                    color="error"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    // variant="dot"
                  >
                    <NotificationsIcon />
                  </Badge>
                </IconButton>
                <Typography className={classes.marginRight}>
                  {profile && profile.name && profile.name}
                </Typography>
                <Tooltip
                  title="Ir a Mi Perfil"
                  aria-label="Ir a Mi Perfil"
                  placement="bottom"
                >
                  <Link to={PROFILE}>
                    <Avatar
                      alt={profile && profile.name ? profile.name : ''}
                      src={avatar ? avatar : defaultAvatar}
                      className={classes.avatar}
                    />
                  </Link>
                </Tooltip>
              </>
            )}
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};
